import { render, staticRenderFns } from "./GoogleAuth.vue?vue&type=template&id=2c0f1c33&scoped=true&"
import script from "./GoogleAuth.vue?vue&type=script&lang=ts&"
export * from "./GoogleAuth.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleAuth.vue?vue&type=style&index=0&id=2c0f1c33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f1c33",
  null
  
)

export default component.exports